import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    height: 52,
    fontSize: 17,
    width: '100%',
    '& .MuiButton-label': {
      justifyContent: 'flex-start',
      marginLeft: 20,
    },
    color: (props) => (props.rCard ? theme.palette.primary.main : 'black'),
    position: 'relative',
  },
  point: {
    color: theme.palette.primary.main,
    fontSize: 14,
    position: 'absolute',
    right: 20,
  },
  iconContainer: {
    height: 52,
    width: 52,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const GenericButton = ({ ...props }) => {
  const { group, isNewItem } = props;
  const rCard = group.title === 'Pagar Tarjeta Ripley';
  const classes = useStyles({ rCard });

  return (
    <React.Fragment>
      <Button
        id={group.id}
        variant="text"
        onClick={
          group.title === 'Cerrar Sesión'
            ? group.route
            : () => window.open(group.route, '_blank')
        }
        className={classes.button}
      >
        <div className={classes.iconContainer}>{group.icon}</div>
        {group.title}
        {isNewItem && <span className={classes.point}>¡Nuevo!</span>}
      </Button>
    </React.Fragment>
  );
};

GenericButton.propTypes = {
  group: PropTypes.object,
  isNewItem: PropTypes.bool,
};

export default GenericButton;
